import { Button } from 'primereact/button'

import DialogContainer, { DialogContainerProps } from '../common/pure/DialogContainer'
import { Column, Row } from '../common/pure/FlexContainer'
import { pi } from '../common/pure/PrimeIcon'
import { downloadPng } from '../../tools/dom/download'
import t from '../../tools/t'

interface QrDialogProps extends DialogContainerProps {
    qr?: string
    name?: string
}
export default function QrDialog({ qr, name, ...props }: QrDialogProps) {
    const downloadQr = () => {
        if (!(name && qr)) return
        downloadPng(name + ' QR', qr)
    }

    return (
        <DialogContainer {...props} header={props.header ?? name}>
            <Column alignment="end" gap={1}>
                <img src={qr} />
                <Row alignment="center" arrangement="spaced" wide>
                    <Button
                        onClick={props.onHide}
                        label={t('common_cancel')}
                        text
                        severity="secondary"
                    />
                    <Button
                        onClick={downloadQr}
                        icon={pi('download')}
                        label={t('common_download')}
                        severity="secondary"
                    />
                </Row>
            </Column>
        </DialogContainer>
    )
}
